/** Aviso no lugar do painel quando o papel nesta organização não alcança a área. */
export function SemPermissao({ area }: { area: string }) {
  return (
    <p className="py-8 text-center text-sm text-zinc-500 dark:text-muted-foreground">
      Seu papel nessa organização não tem acesso a {area}.
    </p>
  );
}
